export default "__VITE_ASSET__DEB$u$gJ__"